module.exports = __webpack_public_path__ + "static/media/neckStrength.917fcc9e.png";